import React, { useState } from 'react';
import { Phone, MapPin, Mail, XIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#081C15] text-white/80 pt-16 pb-8" data-id="element-63">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-65">
            {/* Brand */}
            <div className="lg:col-span-1 flex flex-col items-center text-center" data-id="element-66">
              <img src="https://cdn.magicpatterns.com/uploads/64Tmnvawd7bSgaucnVbdbX/d9a147a9-aeff-42e4-941e-cfb023a07271-Photoroom.png" alt="I&A Landscaping Logo" className="h-20 object-contain mb-6 brightness-0 invert opacity-90 mx-auto" data-id="element-67" />
              <p className="text-sm leading-relaxed mb-6" data-id="element-68">
                Northeast Ohio's premier full-service outdoor transformation
                experts. We show up, do it right, and leave your space looking
                like a million bucks.
              </p>
            </div>

            {/* Contact */}
            <div data-id="element-69">
              <h3 className="text-white font-semibold text-lg mb-4" data-id="element-70">
                Contact Us
              </h3>
              <div className="space-y-3" data-id="element-71">
                <a href="tel:4402221065" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-72">
                  <Phone className="w-4 h-4 flex-shrink-0" data-id="element-73" />
                  <span data-id="element-74">(440) 222-1065</span>
                </a>
                <a href="mailto:iandalanscaping@gmail.com" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-75">
                  <Mail className="w-4 h-4 flex-shrink-0" data-id="element-76" />
                  <span data-id="element-77">iandalanscaping@gmail.com</span>
                </a>
              </div>
              <div className="flex items-center gap-3 mt-5" data-id="element-78">
                <a href="https://www.facebook.com/share/17z3ATukpp/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Facebook" data-id="element-79">
                  <FacebookIcon className="w-4 h-4" data-id="element-80" />
                </a>
                <a href="https://www.instagram.com/i_and_a_landscaping/" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Instagram" data-id="element-81">
                  <InstagramIcon className="w-4 h-4" data-id="element-82" />
                </a>
              </div>
            </div>

            {/* Services */}

            {/* Hours */}
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50" data-id="element-83">
            <p data-id="element-84">
              &copy; {currentYear} I&A Landscaping LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-4" data-id="element-85">
              <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-86">
                Privacy Policy
              </button>
              <span data-id="element-87">|</span>
              <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-88">
                Terms of Service
              </button>
            </div>
            <p data-id="element-89">Transform Your Outdoor Space</p>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-90">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={() => setActiveModal(null)} data-id="element-91">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-92">
              <div className="sticky top-0 bg-white rounded-t-2xl border-b border-gray-100 px-6 py-4 flex items-center justify-between" data-id="element-93">
                <h2 className="text-xl font-bold text-[#081C15]" data-id="element-94">
                  {activeModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-500" data-id="element-95">
                  <XIcon className="w-5 h-5" data-id="element-96" />
                </button>
              </div>

              <div className="px-6 py-6 text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-97">
                {activeModal === 'privacy' ? <>
                    <p className="text-xs text-gray-400" data-id="element-98">
                      Last updated: January 2025
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-99">
                      1. Information We Collect
                    </h3>
                    <p data-id="element-100">
                      We may collect personal information such as your name,
                      email address, phone number, and property address when you
                      contact us for a quote or schedule a service.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-101">
                      2. How We Use Your Information
                    </h3>
                    <p data-id="element-102">
                      Your information is used solely to provide and improve our
                      landscaping services, communicate with you about
                      appointments, and send relevant updates about our
                      offerings.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-103">
                      3. Information Sharing
                    </h3>
                    <p data-id="element-104">
                      We do not sell, trade, or share your personal information
                      with third parties, except as required by law or to
                      fulfill the services you have requested.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-105">
                      4. Data Security
                    </h3>
                    <p data-id="element-106">
                      We implement reasonable security measures to protect your
                      personal information. However, no method of transmission
                      over the internet is 100% secure.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-107">
                      5. Contact Us
                    </h3>
                    <p data-id="element-108">
                      If you have questions about this Privacy Policy, please
                      contact us at iandalanscaping@gmail.com or call us
                      directly.
                    </p>
                  </> : <>
                    <p className="text-xs text-gray-400" data-id="element-109">
                      Last updated: January 2025
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-110">
                      1. Services
                    </h3>
                    <p data-id="element-111">
                      I&A Landscaping LLC provides landscaping, lawn care,
                      hardscaping, and related outdoor services in Northeast
                      Ohio. All services are subject to availability and
                      scheduling.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-112">
                      2. Estimates & Pricing
                    </h3>
                    <p data-id="element-113">
                      All estimates are provided free of charge and are valid
                      for 30 days. Final pricing may vary based on actual site
                      conditions and scope of work agreed upon.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-114">
                      3. Payment Terms
                    </h3>
                    <p data-id="element-115">
                      Payment is due upon completion of services unless
                      otherwise agreed in writing. We accept cash, check, and
                      major credit cards.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-116">
                      4. Cancellations
                    </h3>
                    <p data-id="element-117">
                      We request at least 24 hours notice for cancellations.
                      Repeated no-shows may result in a cancellation fee.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-118">
                      5. Liability
                    </h3>
                    <p data-id="element-119">
                      I&A Landscaping LLC is fully insured. We are not liable
                      for pre-existing conditions on your property or damage
                      caused by weather events during or after service.
                    </p>
                    <h3 className="font-semibold text-[#081C15] text-base" data-id="element-120">
                      6. Contact
                    </h3>
                    <p data-id="element-121">
                      For questions regarding these terms, please reach out to
                      us at iandalanscaping@gmail.com.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}